export default __webpack_public_path__ + "static/donate-branch-d3b10c6b14f58f40ae092b0139e47723.png";